import React from 'react';
import styles from './Dropdown.module.scss';

function Dropdown(props) {
  const { handleItemClick, selectedItem, data } = props;

  return (
    <div className={styles.dropdownWrapper}>
      {data?.map((item) => (
        <div
          className={
            selectedItem?.id === item?.subIssueId
              ? styles.dropdownOptionSelected
              : styles.dropdownOption
          }
          key={item?.subIssueId}
          onClick={() =>
            handleItemClick(
              item?.subIssueId,
              item?.subIssueName,
              item?.skipAllDropDowns,
              item?.supportSystemId,
            )}
        >
          {item?.subIssueName}
        </div>
      ))}
    </div>
  );
}

export default Dropdown;
